<template>
    <div class="Summary" v-if="RecordData.Id">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Basic Info</h4>
                        <p><span class="bold">Family Name: </span><span>{{ RecordData.Name }}</span></p>
                        <p><span class="bold">Case Number: </span><span>{{ RecordData.CaseNumber }}</span></p>
                        <p><span class="bold">Running Summary: </span><span>{{RecordData.RunningSummary }}</span></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GoogleMapsLink from "../../../../Core/LinkShortcuts/GoogleMapsLink.vue";
    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                
            }
        },
        methods: {
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
        },
        components: {
            GoogleMapsLink
        },
        mounted() {
        },
        computed: {
            
        }
    }
</script>

<style scoped>
</style>